import { Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import _get from "lodash/get";
import { formatFieldValue } from "../../../utilities/detailedViewHelpers";

const DetailedMultiGroupTable = ({ group, fields, dataArray, generalInfo }) => {
  if (!Array.isArray(dataArray) || dataArray.length === 0) {
    return null;
  }

  const hasMeaningfulData = dataArray.some((item) =>
    fields.some((field) => {
      let value;

      if (field.isMultiField && field.name === group.name) {
        value = item;
      } else {
        const fieldNameInItem = field.name.substring(field.name.lastIndexOf(".") + 1);
        value = _get(item, fieldNameInItem);
      }

      return value !== null && value !== undefined && value !== "" && !(Array.isArray(value) && value.length === 0);
    })
  );

  if (!hasMeaningfulData) {
    return null;
  }

  return (
    <Card sx={{ mb: 2 }} variant="outlined">
      <CardContent>
        <Typography variant="h6" sx={{ mb: 1, borderBottom: "1px solid #ccc", pb: 0.5 }}>
          {group.label}
        </Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>#</TableCell>
                {fields.map((field) => (
                  <TableCell key={field.name} sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
                    {field.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {dataArray.map((item, index) => (
                <TableRow key={`${group.name}_${index}`} sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" } }}>
                  <TableCell sx={{ fontWeight: "bold" }}>{index + 1}</TableCell>
                  {fields.map((field) => {
                    let value;

                    if (field.isMultiField && field.name === group.name) {
                      value = item;
                    } else {
                      const fieldNameInItem = field.name.substring(field.name.lastIndexOf(".") + 1);
                      value = _get(item, fieldNameInItem);
                    }

                    const formattedValue = formatFieldValue(value, field, generalInfo);
                    return <TableCell key={`${field.name}_${index}`}>{formattedValue}</TableCell>;
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default DetailedMultiGroupTable;
